<template>
  <div class="container-form">
    <div class="row">
      <div class="col-md-12">
        <h2>Configurează contractul de sponsorizare</h2>
        <h4>pasul {{wizardStep}} / {{Object.keys(wizardStepsTitles).length}} - {{wizardStepsTitles[wizardStep]}}</h4>
        <button-icon
          icon-name="chevron_left"
          button-text="pasul anterior"
          :on-click="decrementWizardStep"
        ></button-icon>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from "../global/ButtonIcon";
import { mapState, mapMutations } from "vuex";
import wizardStepsTitles from "../../content/WizardStepsTitles";

export default {
  data() {
    return {
      wizardStepsTitles
    };
  },
  computed: {
    ...mapState({
      wizardStep: state => state.wizardStep
    })
  },
  methods: {
    ...mapMutations(["decrementWizardStep"])
  },
  components: {
    ButtonIcon
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-family: realistnarrow, sans-serif;
  font-weight: 900;
}
</style>


